export const QueryKeys = {
  bitcoinPrice: 'bitcoin/price',
  historyPrice: 'bitcoin/history-price',
  blockHeight: 'blockchain/block-height',
  guardRecords: 'oracle/guards-records',
  contract: 'ducat/contract',
  contractProfile: 'ducat/contractProfile',
  oracleQuote: 'oracle/quote',
  accountVaultList: 'account/vault-list',
  vaultHistory: 'vault/history',
  walletBalance: 'wallet/balance',
  walletRunes: 'wallet/runes-utxos',
  transaction: 'transaction',
  feeRates: 'fee-rates',
  localStorage: 'local-storage',
  overviewHistory: 'overview/history',
  overviewMetrics: 'overview/metrics',
  overviewRange: 'overview/range',
  liqVaults: 'liq/vaults',
  liqLeaderboard: 'liq/leaderboard',
  telegramNotification: 'telegramNotification',
  // quanta API - queries
  quantaCheck: 'quanta/check',
  quantaLogin: 'quanta/login',
  quantaMissions: 'quanta/missions',
  quantaSideMissions: 'quanta/side-missions',
  quantaMissionTasks: 'quanta/mission-tasks',
  quantaSideMissionTasks: 'quanta/side-mission-tasks',
  quantaRanking: 'quanta/ranking',
  // quanta API - mutations
  quantaRegister: 'quanta/register',
  quantaLevel: 'quanta/level',
  quantaCompleteMissionTask: 'quanta/complete-mission-task',
  quantaCompleteMissionTaskPolling: 'quanta/complete-mission-task-polling',
  quantaReferralCheck: 'quanta/referral-check',
  quantaReferralSet: 'quanta/referral-set',
  quantaVerifyTaskSignature: 'quanta/verify-task-signature',
  // faucet API
  faucetReceiveBtc: 'faucet/receive-btc',
  // liquidation tracking API
  liquidationTracking: 'liquidation/tracking',
  // swap API
  submitTransfer: 'swap/submit-transfer',
  swapPsbt: 'swap/psbt',
};
